// extracted by mini-css-extract-plugin
export var displayNone = "_p0-6";
export var imgContainer = "_p0-2";
export var overflowHidden = "_p0-3";
export var productInfoCardButtonContainer = "_p0-5";
export var productTitleText = "_p0-4";
export var rightArrow = "_p0-1";
export var rightArrowContainer = "_p0-0";